export default "__VITE_ASSET__BxIMeFCm__"